<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <v-container>
      <ik-data-table
        ref="table"
        :model="model"
        entity-name="BusinessLayer"
        icon="mdi-cash-usd"
      />
    </v-container>
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import BusinessLayer from '@/model/dataLayer/api/Vip/BusinessLayer'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: BusinessLayer
    })
  }
}
</script>
